<script>
export default {
  name: 'DropList',
  props: {
    dropOption: {
      type: Array,
      default: () => []
    },
    selectedIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      currentIndex: 0,
      dropListIsShow: false
    }
  },
  computed: {
    currentValObj() {
      return this.dropOption && this.dropOption.length > 0 && this.dropOption.filter((item, idx) => this.selectedIndex === idx)[0]
    }
  },
  watch: {
    selectedIndex(newVal) {
      this.currentIndex = newVal
    },
    dropListIsShow(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          setTimeout(() => {
            const scrollIdx = this.selectedIndex === 0 ? 0 : this.selectedIndex - 1
            const activeDom = document.querySelector(`.drop-list-item-${scrollIdx}`)
            const parent = document.querySelector('.drop-list')
            // if (scrollIdx != 0) parent.scrollIntoView({ behavior: 'smooth', block: 'start' })
            scrollIdx == 0
              ? parent.scrollTo({ top: 0, behavior: 'smooth' })
              : activeDom.scrollIntoView({ behavior: 'smooth', block: 'start' })
          }, 200)
        })
      }
    }
  },
  methods: {
    onDropBarClick() {
      this.dropListIsShow = !this.dropListIsShow
    },
    onDropClick(v) {
      this.$emit('onDropClick', v)
      this.dropListIsShow = false
    }
  }
}
</script>

<template>
  <div class="drop-list-container">
    <div class="drop-bar" @click="onDropBarClick">
      <p class="h-line-1 drop-title">{{ currentValObj.label || '请选择' }}</p>
      <i class="el-icon-caret-right" :class="{'icon-rotate': dropListIsShow}" />
    </div>
    <Transition name="drop-list">
      <div v-show="dropListIsShow" class="drop-list">
        <div
          v-for="(v, i) in dropOption"
          :key="`drop-item-${i}`"
          class="drop-list-item"
          :class="[{'drop-list-item-active': i === currentIndex}, `drop-list-item-${i}`]"
          @click="onDropClick(v)"
        >
          <p class="h-line-1 item-title">{{ v.label }}</p>
          <i class="el-icon-arrow-right" />
        </div>
      </div>
    </Transition>
  </div>
</template>

<style lang="scss" scoped>
.drop-list-container {
  width: 385px;
  height: 55px;
  position: relative;
  .drop-list {
    position: absolute;
    left: 0;
    bottom: 35px;
    width: 385px;
    height: 277px;
    background-color: #fff;
    border: 2px solid #D10506;
    // box-shadow: 0px 0px 15px 0px rgba(177,8,8,0.15);
    border-radius: 15px;
    padding: 10px 0 40px;
    display: flex;
    flex-direction: column;
    align-items: center;
    row-gap: 10px;
    // transform: translateY(235px);
    overflow-y: scroll;
    &::-webkit-scrollbar { // chrome/safari
      display: none;
    }
    scrollbar-width: none; // firefox
    -ms-overflow-style: none; // IE10+
    z-index: 3;
    .drop-list-item {
      flex-shrink: 0;
      width: 365px;
      height: 50px;
      background-color: #fff;
      border-radius: 10px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 10px;
      box-sizing: border-box;
      cursor: pointer;
      .item-title {
        width: 300px;
        font-size: 17px;
        font-weight: bold;
        color: #333;
      }
      .el-icon-arrow-right {
        font-size: 16px;
        color: #333;
      }
    }
    .drop-list-item-active {
      background-color: #E62129;
      .item-title, .el-icon-arrow-right {
        color: #fff;
      }
    }
  }
}
.drop-bar {
  position: absolute;
  z-index: 6;
  top: 0;
  bottom: 0;
  width: 385px;
  height: 55px;
  background-color: #fff;
  border: 2px solid #D10506;
  // border-radius: 15px;
  padding: 0 20px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  .drop-title {
    width: 300px;
    font-size: 17px;
    font-weight: bold;
    color: #D20508;
  }
  .el-icon-caret-right {
    font-size: 20px;
    font-weight: bold;
    color: #D20508;
    transition: transform linear .1s;
  }
  .icon-rotate {
    transform: rotate(-90deg);
  }
}

.drop-list-enter-active, .drop-list-leave-active {
  transition: all ease-in-out .2s;
}
.drop-list-enter, .drop-list-leave-to {
  // opacity: 0;
  transform: translateY(277px);
}
.drop-list-enter-to, .drop-list-leave {
  // opacity: 1;
  transform: translateY(0);
}
</style>
